/**
 * Check if this.olddScroll is lesser than the new scrollY. If so that means the user is scrolling down so add a class
 */
window.onscroll = function() {
    if( this.scrollY == 0 ) {
        $('.header').removeClass('header--hide');
    } else {
        if( this.oldScroll < this.scrollY || this.scrollY == 0) {
            $('.header').addClass('header--hide');
        } else {
            $('.header').removeClass('header--hide');
        }
    }

    // Set new base value
    this.oldScroll = this.scrollY;
}
